
import AddLicenceModal from '@/components/AddLicenceModal.vue'
import AddMembershipModal from '@/components/AddMembershipModal.vue'
import HashColor from '@/plugins/hashcolor'
import { useStore } from '@/store'
import User from '@/types/User'
import { getCountryDataList, ICountryData } from 'countries-list'
import Vue from 'vue'

export default Vue.extend({
  components: {
    AddLicenceModal,
    AddMembershipModal,
  },
  name: 'App',
  data: () => ({
    tab: null,
    modifyCountryDialog: false,
  }),
  computed: {
    countriesList(): ICountryData[] {
      return getCountryDataList()
    },
    countryItems(): { text: string; value: string }[] {
      return this.countriesList.map((country) => {
        return { text: country.name, value: country.iso3 }
      })
    },
    licenceTypeItems(): { text: string; value: string }[] {
      return useStore().licenceTypeItems
    },
    inspectUser(): User | null {
      return this.$store.getters.inspectUser
    },
    inspectAuth() {
      return this.$store.getters.inspectAuth
    },
    emailVerified() {
      return true
    },
    inspectUserInitial() {
      if (this.$store.getters.inspectUser) {
        const userName: string = this.$store.getters.inspectUser.name
        const array = userName.split(' ')
        let initials = ''

        array.forEach((element) => (initials += element.charAt(0)))

        if (initials.length === 0) {
          return '?'
        } else {
          return initials
        }
      } else {
        return ''
      }
    },
    licences: function () {
      return this.$store.getters.userLicences
    },
    memberships: function () {
      return this.$store.getters.userMemberships
    },
    isThereUser: function () {
      return (
        this.$store.getters.inspectUser !== null && this.$store.getters.inspectUser !== undefined
      )
    },
    isCollectData: function () {
      return this.$store.getters.inspectUser.isCollectData
    },
    isNewsletter: function () {
      return this.$store.getters.inspectUser.isNewsletter
    },
  },
  methods: {
    modifyCountry(country: string): void {
      if (!this.inspectUser || !country || this.inspectUser.location.country === country) return

      const newUserData: User = this.inspectUser
      newUserData.location.country = country

      this.$store.dispatch('modifyInspectedUser', newUserData)

      this.modifyCountryDialog = false
    },
    getCurrentLicenceText(licType: string): string {
      const type = this.licenceTypeItems.find((item) => item.value === licType)

      if (!type) return 'Invalid value'

      return type.text
    },
    getColor(what: string) {
      return HashColor.get(what)
    },
    capitalizeStr(str: string) {
      return str.charAt(0).toLocaleUpperCase() + str.slice(1)
    },
    isExpired(date: number) {
      return date < Date.now()
    },
    isExpireSoon(date: number) {
      const diff = date - Date.now()

      return diff > 0 && diff < 7 * 24 * 60 * 60 * 1000
    },
  },
  watch: {
    $route(to, from) {
      if (to.params.userId !== from.params.userId) {
        this.$store.dispatch('fetchInspectUser', this.$route.params.userId)
        this.$store.dispatch('fetchUserLicences', this.$route.params.userId)
        this.$store.dispatch('fetchUserMemberships', this.$route.params.userId)
        this.$store.dispatch('fetchUserBillings', this.$route.params.userId)
      }
    },
  },
  created() {
    this.$store.dispatch('fetchInspectUser', this.$route.params.userId)
    this.$store.dispatch('fetchUserLicences', this.$route.params.userId)
    this.$store.dispatch('fetchUserMemberships', this.$route.params.userId)
    this.$store.dispatch('fetchUserBillings', this.$route.params.userId)
  },
})
